import React from "react";
import FunctionHeader from "presentation/components/Header/FunctionHeader";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import { TabPanel, TabView } from "primereact/tabview";
import { useAuthStore } from "presentation/stores/use-auth-store";
import MyEquipmentsTab from "presentation/components/Equipment/MyEquipmentsTab";
import AdminEquipmentsTab from "presentation/components/Equipment/AdminEquipmentsTab";
import AdminVehicleMileageTab from "presentation/components/Equipment/AdminVehicleMileageTab";

const VehiclePage: React.FC = () => {
  // O utilizador precisa de ter acesso à função "vehicles" (ou "equipments" como fallback caso se pretenda o mesmo perfil)
  const { isLoading } = usePermissionCheck({ requiredFunction: "vehicles" });
  const { userPermissions } = useAuthStore();

  const isUserAdmin = (): boolean => {
    return userPermissions?.some((p) => p.role?.name === "Admin") ?? false;
  };

  if (isLoading) {
    return <Spinner />;
  }

  const isAdmin = isUserAdmin();

  return (
    <div>
      <FunctionHeader title="Gestão de Viaturas" />
      <div className="card">
        <TabView>
          <TabPanel header="Minhas Viaturas" leftIcon="pi pi-car mr-2">
            <MyEquipmentsTab showOnlyVehicles={true} />
          </TabPanel>
          {isAdmin && (
            <TabPanel header="Gerir Viaturas" leftIcon="pi pi-cog mr-2">
              <AdminEquipmentsTab showOnlyVehicles={true} />
            </TabPanel>
          )}
          {isAdmin && (
            <TabPanel header="Registo de KMs" leftIcon="pi pi-history mr-2">
              <AdminVehicleMileageTab />
            </TabPanel>
          )}
        </TabView>
      </div>
    </div>
  );
};

export default VehiclePage;
